import { z } from 'zod';

export const DeleteUserSchema = z.object({
  userId: z.string(),
});

export type DeleteUserRequestDto = z.infer<typeof DeleteUserSchema>;

export type DeleteUserResponseDto = void;
